var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReadBlog(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-read-blog"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "read-blog",
    clipPath: "url(#clip-read-blog)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15675",
    "data-name": "Group 15675",
    transform: "translate(7306 10760.102)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15831",
    "data-name": "Group 15831",
    transform: "translate(-7301 -10759.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_27376",
    "data-name": "Rectangle 27376",
    transform: "translate(26.443 0) rotate(90)",
    fill: "none",
    stroke: "#5c6d7e",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.706,
    height: 26.443,
    rx: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32.706,
    height: 24.443,
    rx: 3,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_31649",
    "data-name": "Path 31649",
    d: "M162.216,212H151.863a1.086,1.086,0,0,0,0,2.125h10.353a1.086,1.086,0,0,0,0-2.125Z",
    transform: "translate(-144.625 -203.503)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31650",
    "data-name": "Path 31650",
    d: "M162.216,272H151.863a1.086,1.086,0,0,0,0,2.125h10.353a1.086,1.086,0,0,0,0-2.125Z",
    transform: "translate(-144.625 -259.253)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31651",
    "data-name": "Path 31651",
    d: "M162.216,332H151.863a1.086,1.086,0,0,0,0,2.125h10.353a1.086,1.086,0,0,0,0-2.125Z",
    transform: "translate(-144.625 -315.002)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31652",
    "data-name": "Path 31652",
    d: "M157.761,392h-6.01c-.415,0-.751.476-.751,1.063s.336,1.063.751,1.063h6.01c.415,0,.751-.476.751-1.063S158.176,392,157.761,392Z",
    transform: "translate(-144.625 -370.753)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15831-2",
    "data-name": "Group 15831",
    transform: "translate(11.045 36.049) rotate(-77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31648",
    "data-name": "Path 31648",
    d: "M0,3.75,10.916,0,7.34,10.936,4.919,6.2Z",
    transform: "translate(0 5.797)",
    fill: "#fff",
    stroke: "#5c6d7e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15831-3",
    "data-name": "Group 15831",
    transform: "translate(7.137 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27371",
    "data-name": "Rectangle 27371",
    width: 1.44,
    height: 3.599,
    rx: 0.72,
    transform: "translate(3.456 0)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27374",
    "data-name": "Rectangle 27374",
    width: 1.171,
    height: 3.512,
    rx: 0.585,
    transform: "matrix(0.695, -0.719, 0.719, 0.695, 0, 2.099)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27375",
    "data-name": "Rectangle 27375",
    width: 1.171,
    height: 3.512,
    rx: 0.585,
    transform: "translate(5.136 7.053) rotate(-45)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27373",
    "data-name": "Rectangle 27373",
    width: 1.171,
    height: 3.512,
    rx: 0.585,
    transform: "matrix(-0.017, 1, -1, -0.017, 9.473, 4.838)",
    fill: "#5c6d7e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_27372",
    "data-name": "Rectangle 27372",
    width: 1.171,
    height: 3.512,
    rx: 0.585,
    transform: "matrix(0.695, 0.719, -0.719, 0.695, 7.539, 1.264)",
    fill: "#5c6d7e"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadBlog);
export default __webpack_public_path__ + "static/media/read-blog.26144540819d3d4a2639fcf551e37c58.svg";
export { ForwardRef as ReactComponent };